// AppRoutes.ts
import React from 'react';
import { AppRoute } from './Models/AppRoute';
import EmptyLayout from '../Components/Layout/EmptyLayout';
import LandingLayout from '../Components/Layout/LandingLayout';
import Landing from '../Pages/Landing';
import DashboardPage from '../Pages/Dashboard';
import RequestAccountDeletion from '../Pages/RequestAccountDeletetion';
import MainContent from '../Components/Layout/MainContent';
import Login from '../Components/Content/Login';
import LoginLayout from '../Components/Layout/LoginLayout';

// NEW IMPORTS - Point to the new styled components

import AdminLayout from '../Components/Content/SideBar/SideBar';
import Dashboard from '../../src/Components/Content/Dashboard';
import PlayerListView from '../Components/Content/Players/PlayerListView/PlayerListView';
import PlayerDetailView from '../Components/Content/Players/PlayerDetailView/PlayerDetailView';
import AdministratorListView from '../../src/Components/Content/Administrators/AdministratorListView';


import {
    AppstoreOutlined,
    TeamOutlined,
    NotificationOutlined,
    UserOutlined
} from "@ant-design/icons";
import Logout from '../Components/Content/Logout';
import PlayerManagementPage from '../Pages/Players/PlayerManagementPage';
import AdministratorManagementPage from '../Pages/Administrators/AdministratorManagementPage';
import AdminDetailFormPage from '../Pages/AddAdministrators';




const AppRoutes: AppRoute[] = [
    {
        path: '/',
        element: <Landing />,
        layout: LandingLayout,
        hideInMainMenu: true,
    },
    {
        path: '/RequestAccountDeletion',
        element: <RequestAccountDeletion />,
        hideInMainMenu: true,
        layout: LandingLayout,
    },
    {
        path: '/Login',
        element: <Login />,
        layout: LoginLayout,
        hideInMainMenu: true,
        title: 'Login',
    },
    {
        path: '/Admin',
        skip: true,
        redirect: 'Dashboard',
        icon: <AppstoreOutlined />,
        title: 'Admin',
        routes: [
            {
                path: 'Dashboard',
                element: <Dashboard />,  // ← Uses NEW styled dashboard
                layout: AdminLayout,
                requiredOperations: ['Access Dashboard'],
                hideInMainMenu: false,
                title: 'Dashboard',
                icon: <AppstoreOutlined />,
            },
            {
                path: 'Users',
                layout: AdminLayout,
                requiredOperations: ['Access Dashboard'],
                hideInMainMenu: false,
                title: 'Users',
                icon: <AppstoreOutlined />,
                routes: [
                    {
                        path: 'Players',
                        element: <PlayerListView />,  // ← Uses NEW styled player list
                        layout: AdminLayout,
                        requiredOperations: ['Access Dashboard'],
                        hideInMainMenu: false,
                        title: 'Players',
                        icon: <UserOutlined />,
                        routes: [
                            {
                                path: ':userId',
                                element: <PlayerDetailView />,
                                layout: AdminLayout,
                                requiredOperations: ['Access Dashboard'],
                                hideInMainMenu: true,
                                title: 'Player Details',
                            }
                        ]
                    },
                    {
                        path: 'Administrators',
                        element: <AdministratorListView />,  // ← Uses NEW styled admin list
                        layout: AdminLayout,
                        requiredOperations: ['Access Dashboard'],
                        hideInMainMenu: false,
                        title: 'Administrators',
                        icon: <UserOutlined />,
                        routes: [
                            {
                                path: 'Add',
                                element: <AdminDetailFormPage />,
                                layout: AdminLayout,
                                requiredOperations: ['Access Dashboard'],
                                hideInMainMenu: true,
                                skip: true,
                                title: 'Add Administrator',
                            }
                        ]
                    },
                ]
            },
        ]
    },
    {
        path: '/Logout',
        element: <Logout />,
        layout: LoginLayout,
        hideInMainMenu: true,
        title: 'Logout',
    },
];

export { AppRoutes };